import React, { useState } from "react";
import { toast } from "react-toastify";
import ScrollTop from "../../ScrollTop";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("heading", `New Inquiry Alert from ${formData.name}!`);
    form.append("name", formData.name);
    form.append("email", formData.email);
    form.append("mobileNumber", formData.mobileNumber);
    form.append("message", formData.message);
    form.append("subject", "Contact Form");
    form.append("toEmail", "vexoticcarsofficial@gmail.com");

    fetch("https://api.smartaihr.com/api/users/sendingEmail", {
      method: "POST",
      body: form,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        toast.success("Thank You For Contact Us !");
        setFormData({
          name: "",
          mobileNumber: "",
          email: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Something went wrong. Please try again.");
      });
  };

  return (
    <>
      <ScrollTop />
      <section className="mx-4 lg:mx-16 px-4 sm:px-16 py-7 my-6 sm:my-24 bg-sky-400">
        <h4
          style={{
            fontFamily: "Ballega",
          }}
          className="text-2xl pb-4 sm:text-4xl"
        >
          Get in touch with us!
        </h4>
        <form
          style={{
            fontFamily: "Barlow Condensed",
            fontSize: "16px",
            fontWeight: "700",
          }}
          onSubmit={handleSubmit}
        >
          <label>
            Name
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="arial text-lg font-bold border border-2 border-gray-300 w-full p-2 my-2 outline-none"
              required
            />
          </label>
          <div className="flex gap-4">
            <label className="w-1/2">
              Phone Number
              <input
                type="number"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                className="arial text-lg font-bold border border-2 border-gray-300 w-full p-2 my-2 outline-none"
                pattern="[0-9]{10}"
                maxLength="10"
                min="0"
                required
              />
            </label>
            <label className="w-1/2">
              Email
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="arial text-lg font-bold border border-2 border-gray-300 w-full p-2 my-2 outline-none"
              />
            </label>
          </div>
          <label className="flex flex-col space-y-2">
            <span>Message</span>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="arial text-lg font-bold border border-2 border-gray-300 w-full p-2 my-2 outline-none"
              rows="4"
            ></textarea>
          </label>

          <div className="flex justify-center">
            <button
              type="submit"
              className="px-4 py-2 mt-4 text-white bg-green-700 hover:bg-green-800"
            >
              Contact Us
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default ContactUs;
